import React from 'react';
import { connect } from 'react-redux';
import { formatPricingFactorValue } from '../../../utils/packagesUtils';
import PricingFactorLabel from '../PricingFactorLabel';
import NumberedPricingFactor from '../NumberedPricingFactor';

const isValidRevisions = (revisions) => revisions.every(Boolean);

const Revisions = ({ revisions }) => {
    if (!isValidRevisions(revisions)) {
        return null;
    }
    const { name } = revisions[0];

    return (
        <tr>
            <th>
                <PricingFactorLabel name={name}/>
            </th>
            {revisions.map(({ id, value }) => (
                <NumberedPricingFactor key={id} value={formatPricingFactorValue(value)}/>
            ))}
        </tr>
    );
};

const mapStateToProps = ({ packages }) => ({
    revisions: packages.packageList.map((packageData) => packageData.revisions)
});

export { Revisions };
export default connect(mapStateToProps)(Revisions);
